export default __webpack_public_path__ + "static/medical-loan-baa7ba189cdbe3b5af46947dc0f4bbac.webp";